import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AgreementHandlerKey } from "../../context/AgreementContext";

interface AgreementConfirmDialogProps {
  handlerKey: AgreementHandlerKey | null;
  onConfirm: () => void;
  onCancel: () => void;
  hasDraftComments?: boolean;
}

export const AgreementConfirmDialog = ({
  handlerKey,
  onConfirm,
  onCancel,
  hasDraftComments = false,
}: AgreementConfirmDialogProps) => {
  const { t } = useTranslation();

  if (!handlerKey) return null;
  const showDraftLossWarning =
    hasDraftComments && (handlerKey === "confirm" || handlerKey === "reject");

  return (
    <AlertDialog open={!!handlerKey} onOpenChange={onCancel}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`agreements.dialogs.${handlerKey}.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(`agreements.dialogs.${handlerKey}.description`)}
          </AlertDialogDescription>
          {showDraftLossWarning && (
            <AlertDialogDescription>
              {t("agreements.dialogs.draftCommentsLossWarning")}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t(`agreements.dialogs.${handlerKey}.confirm`)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
